import { $deleteFromArray, $handleError } from "@/utils";
import { ModelsStatus } from "@/components/views/smallModels/config/enum";
import service from "@/components/views/smallModels/service/models.service";
import Vue from "vue";
import router from "@/router";
import { ForgeModelVersion } from "@/scripts/js/forgeModels";
import store from "@/store";
export const MODELS = {
  namespaced: true,
  state: {
    entries: [],
    total: 0,
    loading: false,
    options: {
      search: "",
      status: ModelsStatus.Active,
    },
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_TOTAL(state) {
      return state.total;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_OPTIONS(state) {
      return state.options;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_OPTIONS(state, value) {
      state.options = value;
    },
    SET_OPTIONS_STATUS(state, value) {
      if (!value) value = 0;
      state.options.status = value;
    },
    SET_OPTIONS_SEARCH(state, value) {
      state.options.search = value;
    }
  },
  actions: {
    GET({ commit, state }) {
      commit("SET_LOADING", true);

      state.options.facilityId = router.currentRoute.params.id;

      service
        .get(state.options)
        .then((res) => {
          let data = res.data.items.map(i => Object.assign(new ForgeModelVersion(), i));

          commit("SET_ENTRIES", data);
          commit("SET_TOTAL", res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    DELETE({ state, commit }, id) {
      return service
        .delete(router.currentRoute.params.id, id)
        .then(() => {

          $deleteFromArray(state.entries, id);
          $deleteFromArray(store.state.uploadedModels, id);
          commit("SET_TOTAL", --state.total);

          Vue.prototype.$dialog.notify.success("Deleted Successfully", {
            position: "top-right",
            timeout: 3000,
          });
        })
        .catch((err) => {
          $handleError(err);
        });
    },
    UPDATE_MODEL_STATUS({ dispatch }, { id, status }) {
      service
        .updateModelStatus(id, status)
        .then(() => {
          dispatch("GET");
        })
        .catch((err) => {
          $handleError(err);
        });
    },

  },
};
